import Ambassador from '../ambassador';

/**
 * Create the action
 */

const { thunk, request, success, error } = Ambassador.index((fetch) =>
    fetch.get('ambassador')
);

/**
 * Export the components
 */

export { thunk as default };
export { request, success, error };
